<template>
  <div>
    <LeftListMember :pos="1"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li on">
            <router-link to="" class="txt">公司简介</router-link>
          </li>
        </ul>
        <div class="contect">
          <div class="left">正文内容 <span>*</span></div>
          <div class="right">
            <vue-ueditor-wrap
              v-model="form.introduction"
              editor-id="editor"
              :config="editorConfig"
              :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"

            />
          </div>
          <button class="g-btnsave" v-loading="saving" @click="save" style="margin-top: 10px;">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import getApiData, {getApiRes} from "@/api/apiUtil";
import apiBkCompany from "@/api/bkCompany";
import LeftListMember from "@/components/LeftListMember.vue";
export default {
  components: {
    LeftListMember,
    VueUeditorWrap,
  },
  data() {
    return {
      form: {
        id: undefined,
        introduction: "",
      },
      saving: false,
      // 富文本编辑器
      editorConfig: {
        //serverUrl: process.env.VUE_APP_BASE_API + "/config"',
        //UEditor接口
        serverUrl: "/static/ueditor/php/controller.php",
        //前端资源
        UEDITOR_HOME_URL: process.env.NODE_ENV === 'production' ? '/dist/UEditor/' : "/UEditor/",
        UEDITOR_CORS_URL: process.env.NODE_ENV === 'production' ? '/dist/UEditor/' : "/UEditor/",
        zIndex: 90, //设置z轴顺序值，避免工具栏下拉组件被遮挡
      },
    };
  },
  computed: {},
  mounted() {
    this.load()
  },
  beforeDestroy() {
    // this.save()
  },
  methods: {
    async load(){
      let form = await getApiData(apiBkCompany.getInfo())
      Object.assign(this.form, form)
      this.$store.dispatch('user/updateCompany', form)

      // 检测认证
      if(this.$store.state.user.userInfo.type != 2 && this.$store.state.user.company.status != 2) { //会员和供应商需要认证
        return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
      }
    },
    async save(){
      try {
        this.saving = true
        await getApiRes(apiBkCompany.save(this.form), 0, 1,1,1)
      }catch (e) {
        console.log(e)
      }finally {
        this.saving = false
      }
    }
  },
};
</script>

<style lang="scss" scoped></style>
